import React from 'react';
import { PhoneCall } from 'lucide-react';
export function CallButton() {
  return <a href="tel:+18134768935" className="fixed bottom-24 md:bottom-8 right-4 md:right-8 z-40 bg-mf-red text-white p-4 rounded-full shadow-lg hover:bg-red-700 transition-colors group" aria-label="Call Move Fighters" data-id="element-80">
      {/* Pulse effect rings */}
      <div className="absolute inset-0 rounded-full border-2 border-mf-red animate-ping opacity-75" data-id="element-81"></div>

      <PhoneCall size={32} className="relative z-10" data-id="element-82" />

      {/* Tooltip */}
      <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-mf-black text-white text-sm font-bold px-3 py-1.5 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none" data-id="element-83">
        Call Us Now!
        <div className="absolute top-1/2 -right-1 -translate-y-1/2 border-4 border-transparent border-l-mf-black" data-id="element-84"></div>
      </div>
    </a>;
}